import { EventEmitter, Component, Input, OnInit, Output } from '@angular/core';
import { FilterType, FrontEndColumn } from '@app/shared/interfaces/front-end-column';

@Component({
  selector: 'app-filter-side-bar',
  templateUrl: './filter-side-bar.component.html',
  styleUrls: ['./filter-side-bar.component.less'],
})
export class FilterSideBarComponent implements OnInit {
  FilterType = FilterType;
  @Output() filterExpandedChange: EventEmitter<boolean> = new EventEmitter();
  @Input() filtersApplied: number;
  @Input() columns: FrontEndColumn[] = [];
  @Input() innerContent = document.getElementsByClassName('inner-content')[0];
  @Input() filters: {
    [name: string]: {
      value: string;
      numberFromValue: number | string;
      numberToValue: number | string;
    };
  };

  @Output() applyFilter = new EventEmitter();
  @Output() resetFilters = new EventEmitter();

  constructor() {}

  ngOnInit(): void {}
}
